import { memo } from 'react';
import { type TestProps } from '@direct-frontend/components/testing';
import { ColorDot } from '../../../ColorDot';
import { RadioItem, type RadioItemProps } from '../RadioItem';

export interface ColorDotRadioProps extends RadioItemProps, TestProps {
    /** Цвет точки */
    color?: string;
}

export const ColorDotRadio = memo(function ColorDotRadio({
    'data-testid': dataTestId = 'ColorDotRadio',
    color = '#CCCCCC',
    value,
    ...props
}: ColorDotRadioProps) {
    return (
        <RadioItem
            {...props}
            data-testid={dataTestId}
            value={value}
            aria-label={`Выбрать цвет ${value}`}
            title={value}
            isCircle
        >
            <ColorDot color={color} />
        </RadioItem>
    );
});
